module.exports = __webpack_public_path__ + "media/images/version_merge/mobile_step_template-db63e26334872ad252346b9ae56fbe90.svg";